<template><ProductDetailBase route-key="/products/110kv" /></template>
<script>
import ProductDetailBase from "./ProductDetailBase.vue";
export default { name: "Product110Page", components: { ProductDetailBase } };
</script>
